module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av685-1a93558fe5d97179023a7947be948bc5.jpg";